<template>
    <div v-if="isSlider" class="articles-slider__wrapper">
        <BlockPersonsRow
            swiper
            :loop="false"
            :slides-per-view="3"
            :items="sortedArticles">
            <template #item="{ item }" >
                <ArticleItem class="articles-slider__item" :data="item"/>
            </template>

        </BlockPersonsRow>
    </div>

    <div v-else
        class="articles-list"
        :class="listClasses">
        <div class="articles-list__item"
            :key="index + news.code"
            v-for="(news, index) in sortedArticles">
            <ArticleItem
                full-clickable
                :type="type"
                :data="news"
                :image-size="imageSize" />
        </div>
    </div>
</template>

<script>
import orderBy from 'lodash/orderBy'
import BlockPersonsRow from '@/components/catalog/persons/BlockPersonsRow';
import ArticleItem from '@/components/layout/blocks/ArticlesList/ArticleItem';
export default {
    name: 'ArticlesList',
    components: { ArticleItem, BlockPersonsRow },
    props: {
        type: {
            type: String,
            default: null
        },
        articles: {
            type: Array,
            default: () => []
        },
        isSlider: {
            type: Boolean,
            default: false
        },
        slidesShowed: {
            type: [Number, String],
            default: 'auto'
        },
        slidesSwitching: {
            type: [Number, String],
            default: 3
        },
        noMarginTop: {
            type: Boolean,
            default: false
        },
        dateOrder: {
            type: Boolean,
            default: true
        },
        imageSize: {
            type: String,
            default: ''
        }
    },
    computed: {
        listClasses() {
            return {
                'articles-list_no-margin-top': this.noMarginTop
            }
        },
        swiperOptions() {
            const options = {
                slidesPerView: 'auto',
                slidesPerGroup: this.slidesSwitching,
                spaceBetween: 16,
                setWrapperSize: false,
                navigation: {
                    nextEl: '.articles-list__arrow-next',
                    prevEl: '.articles-list__arrow-prev',
                },
                roundLengths: true
            }

            return options
        },
        sortedArticles() {
            if(this.dateOrder){
                return orderBy(this.articles, article => {
                    return new Date(article.createdAt)
                }, 'desc');
            }else{
                return this.articles
            }
        }
    },
    methods: {
        nextSlide() {
            this.$refs.swiperArticles.$swiper.slideNext()
        },
        prevSlide() {
            this.$refs.swiperArticles.$swiper.slidePrev()
        }
    }
};
</script>

<style lang="less">
.articles-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    margin-top: rem(8);

    .page-padding();

    &__item {
        margin-top: rem(7);
        margin-bottom: rem(13);

        width: calc(50% - rem(8));

        .article-item{
            width: 100%;

            @{mobile} & {
                width: 100%;
            }
        }
    }

    &_no-margin-top {
        margin-top: 0;
    }

    @{desktop} &_related{
        display: block;
        font-size: 0;
        margin-top: rem(-27);
        margin-left: rem(-8);
        margin-right: rem(-8);
            
        .articles-list__item{
            display: inline-block;
            vertical-align: top;
            width: 100%/3;
            padding: rem(24) rem(8) 0;
        }

        .article-item{
            &__picture{
                border-radius: rem(3);

                &-wrapper{
                    border-radius: rem(3);
                }
            }
        }
    }
}

.articles-slider {
    &__item {
        width: rem(194);
    }
    &__slide {
        width: auto;
    }
    &__arrow {
        cursor: pointer;

        height: rem(20);
        width: rem(20);

        position: absolute;
        top: 25%;
        z-index: 10;

        transform: translateY(-50%);

        svg {
            max-height: 100%;
            max-width: 100%;
        }

        &_next {
            right: rem(-35);
        }

        &_prev {
            left: rem(-35);

            transform: rotate(180deg) translateY(calc(-50% + 17px));
            transform-origin: center;
        }
    }
}
</style>
